import { Sparkles, Leaf, Building2, Wind, Paintbrush, Wrench } from "lucide-react";

export const TRADES = [
  {
    slug: "cleaning", name: "Cleaning", category: "Cleaning", Icon: Sparkles,
    blurb: "Regular, deep or end-of-tenancy cleans done the way you'd do them yourself — if you had the time.",
    examples: ["Weekly or fortnightly home clean", "Deep clean", "End-of-tenancy clean", "Oven & appliance clean"],
  },
  {
    slug: "gardening", name: "Gardening", category: "Gardening", Icon: Leaf,
    blurb: "From a tidy-up before guests arrive to keeping the garden looking after itself all season.",
    examples: ["Lawn mowing & edging", "Hedge trimming", "Border weeding & planting", "Garden clearance"],
  },
  {
    slug: "scaffolding", name: "Scaffolding", category: "Scaffolding", Icon: Building2,
    blurb: "Safe, certified access for roofing, rendering and anything up high — erected and struck on schedule.",
    examples: ["Residential scaffold hire", "Chimney & roof access", "Scaffold towers", "Edge protection"],
  },
  {
    slug: "air-conditioning", name: "Air Conditioning", category: "Air Conditioning", Icon: Wind,
    blurb: "Installation, servicing and repairs to keep every room exactly the temperature you want it.",
    examples: ["Split system installation", "Annual service & filter clean", "Fault finding & repair", "Re-gas"],
  },
  {
    slug: "painting-decorating", name: "Painting & Decorating", category: "Painting", Icon: Paintbrush,
    blurb: "Crisp lines, clean finishes and dust sheets on everything. Inside or out, one room or the whole house.",
    examples: ["Interior walls & ceilings", "Woodwork & skirting", "Exterior masonry", "Wallpaper hanging"],
  },
  {
    slug: "plumbing-gas", name: "Plumbing & Gas", category: "Plumbing", Icon: Wrench,
    blurb: "Gas Safe registered engineers for everything from a dripping tap to a new boiler.",
    examples: ["Boiler service & repair", "Leaks, taps & toilets", "Gas safety certificate", "Radiators & heating"],
  },
];

export const TRADE_CATS = ["Plumbing", "Electrical", "Cleaning", "Gardening", "Handyman", "Painting", "Scaffolding", "Air Conditioning", "Renovation", "Building", "Roofing"];
